<div class="fixed inset-0 bg-gray-900/20 backdrop-blur-sm flex items-center justify-center z-[200] p-4"
  (click)="close.emit()">
  <div class="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] flex flex-col" (click)="$event.stopPropagation()">
    <div class="px-6 py-4 border-b border-gray-200 flex-shrink-0">
      <h3 class="text-lg font-semibold text-gray-900">New task</h3>
    </div>

    <div class="px-6 py-4 space-y-4 overflow-y-auto flex-1 min-h-0">
      <!-- Title -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Title *</label>
        <input type="text" [(ngModel)]="form.name" (keyup.enter)="save()"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="What needs to be done?" autofocus>
      </div>

      <!-- Description -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea [(ngModel)]="form.description" rows="2"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Add more detail (optional)"></textarea>
      </div>

      <!-- Status + Priority -->
      <div class="grid grid-cols-2 gap-3">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
          <select [(ngModel)]="form.status"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="TODO">To do</option>
            <option value="IN_PROGRESS">In progress</option>
            <option value="DONE">Done</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Priority</label>
          <select [(ngModel)]="form.priority"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="LOW">Low</option>
            <option value="MEDIUM">Medium</option>
            <option value="HIGH">High</option>
          </select>
        </div>
      </div>

      <!-- Due date -->
      <div class="space-y-2">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" [(ngModel)]="hasDueDate"
            class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
          <span class="text-sm font-medium text-gray-700">Set a due date</span>
        </label>
        @if (hasDueDate) {
        <input type="date" [(ngModel)]="dueDate"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
        }
      </div>

      <!-- Optional scope: Tenant → Client → Project -->
      <div class="bg-gray-50 rounded-xl p-3 space-y-3 border border-gray-100">
        <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Scope (optional)</p>
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Tenant</label>
          <select [(ngModel)]="scope.tenantId" (ngModelChange)="onTenantChange()"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-400">
            <option [ngValue]="undefined">— No tenant —</option>
            @for (t of tenants; track t.id) {
            <option [value]="t.id">{{ t.name }}</option>
            }
          </select>
        </div>
        @if (scope.tenantId) {
        <div class="pl-3 border-l-2 border-blue-200">
          <label class="block text-xs font-medium text-gray-600 mb-1">Client</label>
          <select [(ngModel)]="scope.clientId" (ngModelChange)="onClientChange()"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-400">
            <option [ngValue]="undefined">— No client —</option>
            @for (c of filteredClients; track c.id) {
            <option [value]="c.id">{{ c.name }}</option>
            }
          </select>
        </div>
        }
        @if (scope.clientId) {
        <div class="pl-6 border-l-2 border-purple-200">
          <label class="block text-xs font-medium text-gray-600 mb-1">Project</label>
          <select [(ngModel)]="scope.projectId"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-purple-400">
            <option [ngValue]="undefined">— No project —</option>
            @for (p of filteredProjects; track p.id) {
            <option [value]="p.id">{{ p.projectName }}</option>
            }
          </select>
          @if (filteredProjects.length === 0) {
          <p class="text-xs text-gray-400 mt-1 italic">No projects linked to this client yet</p>
          }
        </div>
        }
      </div>

      <!-- Assign users -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Assign users</label>
        <div class="max-h-40 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
          @for (u of users; track u.id) {
          <label class="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer">
            <input type="checkbox" [checked]="isUserSelected(u.id)" (change)="toggleUser(u.id)"
              class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
            <span class="ml-3 text-sm text-gray-900">{{ u.firstName || '' }} {{ u.name }}</span>
          </label>
          }
          @if (users.length === 0) {
          <div class="px-3 py-2 text-sm text-gray-400 italic">No users available</div>
          }
        </div>
      </div>
    </div>

    <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-2 flex-shrink-0">
      <button (click)="close.emit()"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
        Cancel
      </button>
      <button (click)="save()" [disabled]="!form.name.trim() || saving"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        {{ saving ? 'Creating…' : 'Create task' }}
      </button>
    </div>
  </div>
</div>
